import { render, staticRenderFns } from "./DownloadAlbumModal.vue?vue&type=template&id=bf19739c"
import script from "./DownloadAlbumModal.vue?vue&type=script&lang=js"
export * from "./DownloadAlbumModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports